import os from "os";
import path from "path";

export const PCC_ROOT_DIR = path.join(os.homedir(), ".pcc");
